module.exports = __webpack_public_path__ + "css/matters.svg?d349b6d82ca55624ed34bad7e71809a0";